import script from "./Right_FeaturesApps.vue?vue&type=script&setup=true&lang=js"
export * from "./Right_FeaturesApps.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__